import React from 'react';
import type { ItemType } from '@atlassian/jira-favourite-change-provider/src/model/types.tsx';
import FavoriteButtonStateless from '@atlassian/jira-favourite-button-stateless/src/view/view.tsx';
import FavoriteButton from '@atlassian/jira-favourite-button/src/index.tsx';

type FavoriteButtonProps = {
	isFavoriteInitial: boolean;
	itemId: string;
	itemType: ItemType;
	isSmall?: boolean;
};

export const FavoriteButtonWithSSR = ({
	itemId,
	itemType,
	isFavoriteInitial,
	isSmall,
}: FavoriteButtonProps): React.JSX.Element =>
	__SERVER__ ? (
		<FavoriteButtonStateless isFavorite={isFavoriteInitial} isSmall={isSmall} />
	) : (
		<FavoriteButton
			itemId={itemId}
			itemType={itemType}
			isFavoriteInitial={isFavoriteInitial}
			isSmall={isSmall}
		/>
	);
